import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import {
    Container, Typography, Button, Grid, Card, CardContent, Box,
    AppBar, Toolbar, Table, Chip, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper, Avatar, List, ListItem, ListItemIcon,
    ListItemText, Switch, Backdrop, CircularProgress,
    IconButton,
    Popover,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    DialogContentText,
    useMediaQuery,
    useTheme
} from '@mui/material';
import { Security, Speed, Settings, ArrowForward, ArrowBack, Refresh, InfoOutlined } from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FreeTrialModal from './pricing-tables/FreeTrialModal';
import { IoArrowForwardCircleOutline, IoRefreshCircleOutline, IoSettingsOutline } from 'react-icons/io5';
import ArrowRight from '@untitled-ui/icons-react/build/esm/ArrowRight';
import { LuDatabase, LuMail, LuUser, LuZap } from 'react-icons/lu';
import { API_SERVICE_BACKEND } from 'src/config';
import { getSessionStorage, setSessionStorage } from 'src/utils/storage';
import OneTimePaymentModal from './pricing-tables/OneTimePaymentModal';
import UpgradeConfirmModal from './pricing-tables/UpgradeConfirmModal';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router';

// import FreeTrialModal from './FreeTrialModal'; // Assuming you have a modal component

const NGROK_URL = 'https://testapp-backend-staging.azurewebsites.net';

export default function PricingPage({ fromSettings }) {
    const [isShrunk, setIsShrunk] = useState(false);
    const [cardsHeight, setCardsHeight] = useState(260);
    const cardsRef = useRef(null);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [pricingData, setPricingData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [openModal, setOpenModal] = useState(false);
    const [transformedData, setTransformedData] = useState([]);
    const [allPlansId, setAllPlansId] = useState([]);
    const [packageIntervals, setPackageIntervals] = useState({ 0: 'yearly', 1: 'yearly', 2: 'yearly', 3: 'yearly' });
    const [hideList, setHideList] = useState(false);
    const [subscriptionType, setSubscriptionType] = useState(null);
    const [isSubscribedToPaidPlan, setIsSubscribedToPaidPlan] = useState(false);
    const [subscriptionID, setSubscriptionID] = useState('');
    const [userDetail, setUserDetail] = useState({});
    const [disBtn, setDisBtn] = useState(false);
    const [packageInterval, setPackageInterval] = useState("yearly");
    const [hasShrunk, setHasShrunk] = useState(false);
    const [currentPlanAnchor, setCurrentPlanAnchor] = useState(null);
    const [openTrialModal, setOpenTrialModal] = useState(false);
    const [showUpgradeConfirmDialog, setShowUpgradeConfirmDialog] = useState(false);
    const [showCouponDialog, setShowCouponDialog] = useState(false);
    const [showOneTimeCostDialog, setShowOneTimeCostDialog] = useState(false);
    const [couponCode, setCouponCode] = useState('');
    const [currentSubscription, setCurrentSubscription] = useState('');
    const [durationInMonth, setDurationInMonth] = useState('');
    const [cancelledSubscription, setCancelledSubscription] = useState(false);
    const [updatedSubscription, setUpdatedSubscription] = useState('');
    const [updateDate, setUpdateDate] = useState('');
    const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false);
    const navigate = useNavigate();

    const isCurrentPlanPopoverOpen = Boolean(currentPlanAnchor);
    const email = getSessionStorage("userEmail");
    const hideData = fromSettings ?? false
    const theme = useTheme();
    const isBelow1140 = useMediaQuery('(max-width:1140px)');
    console.log(isBelow1140, 'isBelow1140isBelow1140isBelow1140')

    const data = [
        {
            section: "AI Agents",
            features: [
                { title: "AI Agents", plans: ["", "Unlimited", "Unlimited", "Unlimited"] },
                { title: "AI Knowledge Base", plans: ["", "1,000 Pages", "10,000 pages", "50,000 pages"] },
                { title: "AI Voice Agent", plans: ["", "❌", "500 min /mo", "2,500 min /mo"] },
                { title: "AI Copilot", plans: ["", "❌", "✅", "✅"] },
                { title: "AI Copywriting", plans: ["", "✅", "✅", "✅"] },
                { title: "AI Auto Replies", plans: ["", "✅", "✅", "✅"] }
            ],
            icon: <LuUser />
        },
        {
            section: "B2B Contact Database",
            features: [
                { title: "Contact & Company Lookups", plans: ["", "Unlimited", "Unlimited", "Unlimited"] },
                { title: "User Uploaded Data", plans: ["", "Unlimited", "Unlimited", "Unlimited"] },
                { title: "Database Credits*", plans: ["", "2,000 /mo", "10,000 /mo", "25,000 /mo"] },
                { title: "Email Verification*", plans: ["", "2,000 /mo", "10,000 /mo", "25,000 /mo"] },
                { title: "Buying Intent Data", plans: ["", "1 Topic", "5 Topics", "12 Topics"] },
                { title: "Website Visitor Identification*", plans: ["", "❌", "1,000 /mo", "5,000 /mo"] }
            ],
            icon: <LuDatabase />,
        },
        {
            section: "Outreach",
            features: [
                { title: "Email Sending", plans: ["", "Unlimited", "Unlimited", "Unlimited"] },
                { title: "Deal Pipeline(s)", plans: ["", "1", "5", "20"] },
                { title: "User Brought Mailboxes*", plans: ["", "1", "5", "20"] },
                { title: "Multichannel Accounts*", plans: ["", "1", "1", "5"] },
                { title: "A/B Testing Variations", plans: ["", "❌", "✅", "✅"] },
                { title: "Custom Domain Tracking", plans: ["", "❌", "✅", "✅"] },
                { title: "DFY Mailboxes & Domains*", plans: ["", "✅", "✅", "✅"] },
                { title: "Unified Inbox", plans: ["", "✅", "✅", "✅"] },
                { title: "Dashboard", plans: ["", "✅", "✅", "✅"] },
                { title: "Outreach Analytics", plans: ["", "✅", "✅", "✅"] },
                { title: "Global Blocklist", plans: ["", "✅", "✅", "✅"] }
            ],
            icon: <LuMail />
        },
        {
            section: "General",
            features: [
                { title: "Team Member Seats*", plans: ["", "1", "3", "5"] },
                { title: "Salesforce", plans: ["", "❌", "✅", "✅"] },
                { title: "Hubspot", plans: ["", "❌", "✅", "✅"] },
                { title: "Zoho", plans: ["", "❌", "✅", "✅"] },
                { title: "Zapier", plans: ["", "✅", "✅", "✅"] },
                { title: "Workspaces", plans: ["", "✅", "✅", "✅"] },
                { title: "Weekly Webinars", plans: ["", "✅", "✅", "✅"] },
                { title: "Live Chat Support", plans: ["", "✅", "✅", "✅"] },
                { title: "Help Center", plans: ["", "✅", "✅", "✅"] },
                { title: "1 on 1 Voice/Video Support", plans: ["", "✅", "✅", "✅"] }
            ],
            icon: <IoSettingsOutline />
        },
        {
            section: "Add-Ons",
            features: [
                { title: "Database Credits", plans: ["", "$25 per 500 /mo", "$25 per 500 /mo", "$25 per 500 /mo"] },
                { title: "Email Verification Credits", plans: ["", "$10 per 2,500 /mo", "$10 per 2,500 /mo", "$10 per 2,500 /mo"] },
                { title: "User Brought Mailboxes", plans: ["", "$3 /mo", "$3 /mo", "$3 /mo"] },
                { title: "DFY Domains & Mailboxes", plans: ["", "$3.5 /mo & $13 /yr", "$3.5 /mo & $13 /yr", "$3.5 /mo & $13 /yr"] },
                { title: "Additional Team Members", plans: ["", "$100 / user / mo", "$100 / user / mo", "$100 / user / mo"] },
                { title: "Multichannel Accounts", plans: ["", "❌", "$20 / account / mo", "$20 / account / mo"] }
            ],
            icon: <LuZap />
        }


    ];




    const checkIcon = (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="20" height="20" rx="10" fill="#00AA38" />
            <path d="M13.6668 7.25L8.62516 12.2917L6.3335 10" stroke="white" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    const closeIcon = (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="20" height="20" rx="10" fill="#717680" fillOpacity="0.5" />
            <path d="M12.75 7.25L7.25 12.75M7.25 7.25L12.75 12.75" stroke="white" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    const badgeComingSoon = (
        <svg width="42" height="22" viewBox="0 0 42 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 6C0 2.68629 2.68629 0 6 0H36C39.3137 0 42 2.68629 42 6V16C42 19.3137 39.3137 22 36 22H6C2.68629 22 0 19.3137 0 16V6Z" fill="#5862FF" fillOpacity="0.5" />
            <path d="M0.5 6C0.5 2.96243 2.96243 0.5 6 0.5H36C39.0376 0.5 41.5 2.96243 41.5 6V16C41.5 19.0376 39.0376 21.5 36 21.5H6C2.96243 21.5 0.5 19.0376 0.5 16V6Z" stroke="#5862FF" strokeOpacity="0.5" />
            <text x="6" y="15" fill="white" fontSize="10" fontWeight="bold">Coming Soon</text>
        </svg>
    );

    const badgeCommingSoon = (<svg width="42" height="22" viewBox="0 0 42 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 6C0 2.68629 2.68629 0 6 0H36C39.3137 0 42 2.68629 42 6V16C42 19.3137 39.3137 22 36 22H6C2.68629 22 0 19.3137 0 16V6Z" fill="#5862FF" fill-opacity="0.5" />
        <path d="M0.5 6C0.5 2.96243 2.96243 0.5 6 0.5H36C39.0376 0.5 41.5 2.96243 41.5 6V16C41.5 19.0376 39.0376 21.5 36 21.5H6C2.96243 21.5 0.5 19.0376 0.5 16V6Z" stroke="#5862FF" stroke-opacity="0.5" />
        <path d="M12.041 8.56534C11.9956 8.16193 11.8081 7.84943 11.4785 7.62784C11.149 7.40341 10.7342 7.29119 10.2342 7.29119C9.87624 7.29119 9.56658 7.34801 9.30522 7.46165C9.04386 7.57244 8.84073 7.72585 8.69585 7.92188C8.5538 8.11506 8.48278 8.33523 8.48278 8.58239C8.48278 8.78977 8.53107 8.96875 8.62766 9.11932C8.7271 9.26989 8.85636 9.39631 9.01545 9.49858C9.17738 9.59801 9.35067 9.68182 9.53533 9.75C9.71999 9.81534 9.89755 9.86932 10.068 9.91193L10.9203 10.1335C11.1987 10.2017 11.4842 10.294 11.7768 10.4105C12.0694 10.527 12.3407 10.6804 12.5907 10.8707C12.8407 11.0611 13.0424 11.2969 13.1958 11.5781C13.3521 11.8594 13.4302 12.196 13.4302 12.5881C13.4302 13.0824 13.3024 13.5213 13.0467 13.9048C12.7939 14.2884 12.426 14.5909 11.943 14.8125C11.4629 15.0341 10.8819 15.1449 10.2001 15.1449C9.5467 15.1449 8.98136 15.0412 8.50408 14.8338C8.02681 14.6264 7.65323 14.3324 7.38335 13.9517C7.11346 13.5682 6.96431 13.1136 6.9359 12.5881H8.25692C8.28249 12.9034 8.38477 13.1662 8.56374 13.3764C8.74556 13.5838 8.9771 13.7386 9.25835 13.8409C9.54244 13.9403 9.85352 13.9901 10.1916 13.9901C10.5637 13.9901 10.8947 13.9318 11.1845 13.8153C11.4771 13.696 11.7072 13.5312 11.8748 13.321C12.0424 13.108 12.1262 12.8594 12.1262 12.5753C12.1262 12.3168 12.0524 12.1051 11.9047 11.9403C11.7598 11.7756 11.5623 11.6392 11.3123 11.5312C11.0652 11.4233 10.7853 11.3281 10.4728 11.2457L9.44158 10.9645C8.74272 10.7741 8.18874 10.4943 7.77965 10.125C7.3734 9.75568 7.17028 9.26705 7.17028 8.65909C7.17028 8.15625 7.30664 7.71733 7.57937 7.34233C7.8521 6.96733 8.22141 6.67614 8.68732 6.46875C9.15323 6.25852 9.6788 6.15341 10.264 6.15341C10.8549 6.15341 11.3762 6.2571 11.8279 6.46449C12.2825 6.67188 12.6404 6.95739 12.9018 7.32102C13.1632 7.68182 13.2995 8.09659 13.3109 8.56534H12.041ZM17.6586 15.1321C17.0449 15.1321 16.5094 14.9915 16.052 14.7102C15.5946 14.429 15.2395 14.0355 14.9867 13.5298C14.7338 13.0241 14.6074 12.4332 14.6074 11.7571C14.6074 11.0781 14.7338 10.4844 14.9867 9.97585C15.2395 9.46733 15.5946 9.07244 16.052 8.79119C16.5094 8.50994 17.0449 8.36932 17.6586 8.36932C18.2722 8.36932 18.8077 8.50994 19.2651 8.79119C19.7225 9.07244 20.0776 9.46733 20.3304 9.97585C20.5833 10.4844 20.7097 11.0781 20.7097 11.7571C20.7097 12.4332 20.5833 13.0241 20.3304 13.5298C20.0776 14.0355 19.7225 14.429 19.2651 14.7102C18.8077 14.9915 18.2722 15.1321 17.6586 15.1321ZM17.6628 14.0625C18.0605 14.0625 18.3901 13.9574 18.6515 13.7472C18.9128 13.5369 19.106 13.2571 19.231 12.9077C19.3588 12.5582 19.4228 12.1733 19.4228 11.7528C19.4228 11.3352 19.3588 10.9517 19.231 10.6023C19.106 10.25 18.9128 9.96733 18.6515 9.75426C18.3901 9.54119 18.0605 9.43466 17.6628 9.43466C17.2623 9.43466 16.9299 9.54119 16.6657 9.75426C16.4043 9.96733 16.2097 10.25 16.0819 10.6023C15.9569 10.9517 15.8944 11.3352 15.8944 11.7528C15.8944 12.1733 15.9569 12.5582 16.0819 12.9077C16.2097 13.2571 16.4043 13.5369 16.6657 13.7472C16.9299 13.9574 17.2623 14.0625 17.6628 14.0625ZM24.889 15.1321C24.2754 15.1321 23.7399 14.9915 23.2825 14.7102C22.8251 14.429 22.47 14.0355 22.2172 13.5298C21.9643 13.0241 21.8379 12.4332 21.8379 11.7571C21.8379 11.0781 21.9643 10.4844 22.2172 9.97585C22.47 9.46733 22.8251 9.07244 23.2825 8.79119C23.7399 8.50994 24.2754 8.36932 24.889 8.36932C25.5027 8.36932 26.0382 8.50994 26.4956 8.79119C26.9529 9.07244 27.3081 9.46733 27.5609 9.97585C27.8137 10.4844 27.9402 11.0781 27.9402 11.7571C27.9402 12.4332 27.8137 13.0241 27.5609 13.5298C27.3081 14.0355 26.9529 14.429 26.4956 14.7102C26.0382 14.9915 25.5027 15.1321 24.889 15.1321ZM24.8933 14.0625C25.291 14.0625 25.6206 13.9574 25.8819 13.7472C26.1433 13.5369 26.3365 13.2571 26.4615 12.9077C26.5893 12.5582 26.6532 12.1733 26.6532 11.7528C26.6532 11.3352 26.5893 10.9517 26.4615 10.6023C26.3365 10.25 26.1433 9.96733 25.8819 9.75426C25.6206 9.54119 25.291 9.43466 24.8933 9.43466C24.4927 9.43466 24.1603 9.54119 23.8961 9.75426C23.6348 9.96733 23.4402 10.25 23.3123 10.6023C23.1873 10.9517 23.1248 11.3352 23.1248 11.7528C23.1248 12.1733 23.1873 12.5582 23.3123 12.9077C23.4402 13.2571 23.6348 13.5369 23.8961 13.7472C24.1603 13.9574 24.4927 14.0625 24.8933 14.0625ZM30.6365 11.1136V15H29.3624V8.45455H30.5854V9.51989H30.6664C30.8169 9.1733 31.0527 8.89489 31.3738 8.68466C31.6976 8.47443 32.1053 8.36932 32.5968 8.36932C33.0428 8.36932 33.4334 8.46307 33.7686 8.65057C34.1039 8.83523 34.3638 9.1108 34.5485 9.47727C34.7331 9.84375 34.8255 10.2969 34.8255 10.8366V15H33.5513V10.9901C33.5513 10.5156 33.4277 10.1449 33.1806 9.87784C32.9334 9.60795 32.5939 9.47301 32.1621 9.47301C31.8667 9.47301 31.6039 9.53693 31.3738 9.66477C31.1465 9.79261 30.9661 9.98011 30.8326 10.2273C30.7019 10.4716 30.6365 10.767 30.6365 11.1136Z" fill="#DDE6FF" />
    </svg>)

    const FeatureIcon = ({ value }) => {
        if (value === "✅") {
            return <Box display="flex" alignItems="center">{checkIcon}</Box>;
        }

        if (value === "❌") {
            return <Box display="flex" alignItems="center">{closeIcon}</Box>;
        }

        if (value?.includes("Coming Soon")) {
            return <Box display="flex" alignItems="center">{badgeCommingSoon}</Box>;
        }

        if (value === "") {
            return null;
        }

        return <Box display="flex" alignItems="center">{checkIcon}</Box>;
    };


    const FeatureIconMain = ({ value, title }) => {
        if (value === "✅") {
            return (
                <Box display="flex" alignItems="center">
                    {checkIcon}
                    <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>{title}</Typography>
                </Box>
            );
        }

        if (value === "❌") {
            return (
                <Box display="flex" alignItems="center">
                    {closeIcon}
                    <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>{title}</Typography>
                </Box>
            );
        }

        if (value?.includes("Coming Soon")) {
            return (
                <Box display="flex" alignItems="center">
                    {badgeCommingSoon}
                    {/* Optionally add title beside the badge */}
                    <Typography variant="body2" sx={{ ml: 1, color: theme => theme.palette.text.secondary }}>{title}</Typography>
                </Box>
            );
        }

        if (value === "") {
            return null; // Don’t render anything if value is empty
        }

        return (
            <Box display="flex" alignItems="center">
                {checkIcon}
                <Typography variant="body2" sx={{ mx: 1, color: theme => theme.palette.text.primary }}>{value}</Typography>
                <Typography variant="body2" sx={{ color: theme => theme.palette.text.secondary }}>{title}</Typography>
            </Box>
        );
    };



    const openCurrentPlanPopover = (event) => {
        setCurrentPlanAnchor(event.currentTarget);
    };

    const closeCurrentPlanPopover = () => {
        setCurrentPlanAnchor(null);
    };


    const freeTrialObject = {
        id: 'trial',
        name: 'Trial',
        isPopular: false,
        monthlyPrice: {
            yearly: 0,
            quarterly: 0,
        },
        originalPrice: {
            yearly: 0,
            quarterly: 0,
        },
        prices: {},
    };

    // Open Free Trial Modal
    const handleOpenTrialModal = () => {
        setOpenTrialModal(true);
    };

    // Close Free Trial Modal
    const handleCloseTrialModal = () => {
        setOpenTrialModal(false);
    };

    const handleButtonClick = async (plan) => {
        setSelectedPlan(plan)
        if (isSubscribedToPaidPlan) {
            setShowUpgradeConfirmDialog(true);
            return;
        }
        setShowOneTimeCostDialog(true);
    };

    const handleConfirmUpgrade = async () => {
        setShowUpgradeConfirmDialog(false);
        setShowCouponDialog(true);
    };

    const handleUpgradeWithCoupon = async (couponCode) => {
        const capitalized = packageIntervals[0] && packageIntervals[0]?.charAt(0).toUpperCase() + packageIntervals[0]?.slice(1);

        try {
            setShowCouponDialog(false);
            setIsLoading(true);

            const priceIds = allPlansId
                .filter(plan => plan.type === selectedPlan.name)
                .map(plan => plan.id);

            const data = {
                userEmail: email,
                packageName: `${selectedPlan.name} Package ${capitalized}`,
                priceIds,
                coupon: couponCode || null,
            };

            await axios.post(`${API_SERVICE_BACKEND}/update-subscription`, data);
            toast.success("Subscription updated successfully!");

        } catch (error) {
            toast.error(error.response?.data?.error || error.message || "Unknown error");
        } finally {
            setIsLoading(false);
        }
    };


    const handleConfirmOneTimeCost = async (addOn) => {
        setShowOneTimeCostDialog(false);
        console.log(allPlansId, 'Plans with selectedDuration')

        // Get all price ids according to the selected interval
        // const priceIds = transformedData.map(plan => plan.prices[packageIntervals[0]]?.id).filter(Boolean);
        const priceIds = allPlansId
            .filter(plan => plan.type === selectedPlan.name)
            .map(plan => plan.id);


        console.log(priceIds, selectedPlan, 'priceIdsArraypriceIdsArraypriceIdsArray')
        // Now send the array to handleCheckout
        handleCheckout(priceIds, addOn);
    };


    const handleCheckout = async (priceIds, addOn) => {
        setIsLoading(true);

        try {
            const response = await fetch(`${API_SERVICE_BACKEND}/localized-checkout-session`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    userEmail: email,
                    isPricingPage: true,
                    priceIds,
                    isAddonIncluded: addOn,
                }),
            });

            const data = await response.json();

            if (data.url) {
                window.location.href = data.url;
            } else {
                throw new Error(data.message || "Unknown error");
            }

        } catch (err) {
            console.error('Checkout error', err);
            toast.error(err.message || "Checkout failed");
        } finally {
            setIsLoading(false);
        }
    };




    useEffect(() => {
        const storedType = getSessionStorage("SubscriptionType");
        const storedId = getSessionStorage("SubscriptionPriceId");

        console.log(storedType, 'stored SubscriptionType');
        setSubscriptionType(storedType?.toLowerCase() || '');
        setSubscriptionID(storedId || '');

        if (storedType) {
            const lowerCaseType = storedType.toLowerCase();
            setIsSubscribedToPaidPlan(['basic', 'scale', 'unlimited'].includes(lowerCaseType));
        } else {
            setIsSubscribedToPaidPlan(false);
        }
    }, []);


    const getPricingData = async () => {
        try {
            const response = await axios.get(
                `${API_SERVICE_BACKEND}/stripe-localized-products?region=usa`,
                {
                    headers: {
                        'Accept': 'application/json',
                        'ngrok-skip-browser-warning': 'true' // Skip ngrok warning
                    }
                }
            );
            setPricingData(response.data);
            setIsLoading(false);
        } catch (error) {
            console.error('Error fetching pricing data:', error);
            setIsLoading(false);
        }
    };
    const handleFreeTrialSubscription = async (plan) => {
        try {
            setIsLoading(true);

            const response = await fetch(`${API_SERVICE_BACKEND}/free-trial-subscription`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ userEmail: email, plan }),
            });

            const data = await response.json();

            if (response.ok) {
                setSubscriptionType('trial');
                toast.success("Successfully subscribed to the Free Trial!");
            } else {
                toast.error(`Failed to subscribe: ${data.message || "Unknown error"}`);
            }
        } catch (error) {
            console.error("Error subscribing to Free Trial:", error);
            toast.error(error.message || "An error occurred while processing your request.");
        } finally {
            setIsLoading(false);
        }
    };


    useEffect(() => {
        getPricingData();
    }, []);

    function transformPlans(products, selectedDuration) {
        const staticFeatures = {
            Basic: [
                "2,000 Contacts Monthly",
                "AI Email Auto Replies",
                "Email Outreach",
            ],
            Scale: [
                "10,000 Contacts Monthly",
                "Website Visitor Identification",
                "Multichannel Outreach",
                "A/B Testing Variations",
                "Hubspot & Zoho Integrations",
            ],
            Unlimited: [
                "25,000 Contacts Monthly",
                "Salesforce Integration",
                "5 Team Member Seats Included",
            ],
        };

        const merged = {
            Basic: { total: 0, prices: [] },
            Scale: { total: 0, prices: [] },
            Unlimited: { total: 0, prices: [] },
        };

        const selectedPriceIds = [];

        for (const product of products) {
            for (const price of product.priceList) {
                const type = price.metadata?.type;
                const duration = price.durationInMonths;

                if ((type in merged) && duration === selectedDuration) {
                    merged[type].total += price.unit_amount;
                    merged[type].prices.push(price);
                    selectedPriceIds.push({ id: price.id, type });
                }
            }
        }

        const durationKey = selectedDuration === 12 ? "yearly" : "quarterly";

        const transformedData = Object.keys(merged).map((type) => {
            const totalCents = merged[type].total;
            const monthlyPrice = selectedDuration === 12
                ? totalCents / 12 / 100
                : totalCents / 3 / 100;

            return {
                id: type.toLowerCase(),
                name: type.charAt(0).toUpperCase() + type.slice(1),
                isPopular: type === "Scale",
                monthlyPrice: {
                    yearly: selectedDuration === 12 && monthlyPrice,
                    quarterly: selectedDuration === 3 && monthlyPrice,
                },
                originalPrice: {
                    yearly: selectedDuration === 12 && totalCents / 100,
                    quarterly: selectedDuration === 3 && totalCents / 100,
                },
                calculatedMonthlyPrice: selectedDuration === 12
                    ? totalCents / 12 / 100
                    : undefined,
                featuresList2: staticFeatures[type],
                featuresList1: ["No credit card required", "Access to free tools"],
                prices: merged[type].prices,
            };
        });

        return {
            transformedData,
            selectedPriceIds
        };
    }

    // useEffect(() => {
    //   const selectedDuration = packageIntervals[0] === 'yearly' ? 12 : 3;
    //   const plans = transformPlans(pricingData, selectedDuration);
    //   console.log(plans,packageIntervals,'vfdvdfvdfvd'); // final 3 plan objects
    //   setTransformedData(plans?.transformedData)
    //   setAllPlansId(plans?.selectedPriceIds)
    // }, [packageIntervals,pricingData]);











    // const transformedData = [{
    //   id: 'free',
    //   name: 'Free',
    //   isPopular: false,
    //   monthlyPrice: {
    //     yearly: 0,
    //     quarterly: 0,
    //   },
    //   originalPrice: {
    //     yearly: 0,
    //     quarterly: 0,
    //   },
    //   featuresList1: ['Limited Access', 'Basic Features', 'No credit card required'],
    //   featuresList2: ['No credit card required', 'Access to free tools'],
    //   prices: {},
    // }, {
    //   id: 'free',
    //   name: 'Free',
    //   isPopular: false,
    //   monthlyPrice: {
    //     yearly: 0,
    //     quarterly: 0,
    //   },
    //   originalPrice: {
    //     yearly: 0,
    //     quarterly: 0,
    //   },
    //   featuresList1: ['Limited Access', 'Basic Features', 'No credit card required'],
    //   featuresList2: ['No credit card required', 'Access to free tools'],
    //   prices: {},
    // }, {
    //   id: 'free',
    //   name: 'Free',
    //   isPopular: false,
    //   monthlyPrice: {
    //     yearly: 0,
    //     quarterly: 0,
    //   },
    //   originalPrice: {
    //     yearly: 0,
    //     quarterly: 0,
    //   },
    //   featuresList1: ['Limited Access', 'Basic Features', 'No credit card required'],
    //   featuresList2: ['No credit card required', 'Access to free tools'],
    //   prices: {},
    // },]


    console.log(transformedData, 'transformedData=>')

    useEffect(() => {
        const selectedDuration = Object.values(packageIntervals)[0] === 'yearly' ? 12 : 3;
        const plans = transformPlans(pricingData, selectedDuration);
        console.log(plans, packageIntervals, 'Plans with selectedDuration');
        setTransformedData(plans?.transformedData);
        setAllPlansId(plans?.selectedPriceIds);
    }, [packageIntervals, pricingData]);
    console.log(allPlansId, pricingData, 'Plans with selectedDuration')
    const handleSwitchChange = () => {
        setPackageIntervals((prevIntervals) => {
            const values = Object.values(prevIntervals);
            const isCurrentlyMonthly = values.every(interval => interval === 'quarterly');
            const newInterval = isCurrentlyMonthly ? 'yearly' : 'quarterly';

            const updatedIntervals = {};
            Object.keys(prevIntervals).forEach(key => {
                updatedIntervals[key] = newInterval;
            });

            return updatedIntervals;
        });
    };




    useEffect(() => {
        if (cardsRef.current) {
            setCardsHeight(isShrunk ? (cardsRef.current.offsetHeight === 0 ? 260 : cardsRef.current.offsetHeight) : cardsRef.current.offsetHeight);
        }
    }, [isShrunk]);

    const scrollRef = useRef(null);


    useEffect(() => {
        const measureHeight = () => {
            if (cardsRef.current) {
                setCardsHeight(cardsRef.current.offsetHeight);
            }
        };

        // Measure once when page loads
        measureHeight();

        // Measure again when window resizes
        window.addEventListener('resize', measureHeight);

        return () => window.removeEventListener('resize', measureHeight);
    }, []);



    // useEffect(() => {
    //   const handleScroll = () => {
    //     const scrollTop = window.scrollY;
    //     console.log(scrollTop, 'scrollTopscrollTopscrollTopscrollTop')
    //     setIsShrunk(scrollTop > 120);
    //   };

    //   window.addEventListener('scroll', handleScroll);
    //   return () => window.removeEventListener('scroll', handleScroll);
    // }, []);
    useEffect(() => {
        // Track if we're in the middle of transition
        let isTransitioning = false;
        // Track scroll distance from top to prevent oscillation
        let lastScrollTop = 0;
        // Minimum scroll amount needed before allowing unshrink
        const SCROLL_THRESHOLD = 50;
        // How long to wait before allowing another state change
        const TRANSITION_COOLDOWN = 300;

        const handleScroll = (e) => {
            if (!scrollRef.current) return;

            const scrollTop = scrollRef.current.scrollTop;
            const deltaY = e.deltaY;
            const scrollingDown = deltaY > 0;
            const scrollingUp = deltaY < 0;

            // Prevent state changes during transition
            if (isTransitioning) {
                // Still allow scrolling content, just not state changes
                scrollRef.current.scrollTop += deltaY;
                return;
            }

            // When scrolling down from the very top, shrink immediately
            if (scrollingDown && scrollTop <= 0 && !isShrunk) {
                setIsShrunk(true);
                setHasShrunk(true);
                lastScrollTop = 0;

                // Lock transitions temporarily
                isTransitioning = true;
                setTimeout(() => {
                    isTransitioning = false;
                }, TRANSITION_COOLDOWN);

                // Continue scrolling after shrinking
                scrollRef.current.scrollTop += deltaY;
                return;
            }

            // When scrolling up and already scrolled enough, unshrink when reaching top
            if (scrollingUp && isShrunk) {
                // Only allow unshrink if user has scrolled down enough before
                if (lastScrollTop >= SCROLL_THRESHOLD && scrollTop <= 0) {
                    setIsShrunk(false);
                    setHasShrunk(false);

                    // Prevent immediate re-shrinking
                    isTransitioning = true;
                    setTimeout(() => {
                        isTransitioning = false;
                    }, TRANSITION_COOLDOWN);

                    e.preventDefault(); // Prevent bounce
                    return;
                }
            }

            // Normal scrolling
            scrollRef.current.scrollTop += deltaY;

            // Keep track of max scroll position to determine if user has scrolled enough
            lastScrollTop = Math.max(lastScrollTop, scrollTop);

            // If scrolled beyond threshold, always ensure shrunk state
            if (scrollTop > 10 && !isShrunk) {
                setIsShrunk(true);
                setHasShrunk(true);

                // Lock transitions temporarily
                isTransitioning = true;
                setTimeout(() => {
                    isTransitioning = false;
                }, TRANSITION_COOLDOWN);
            }
        };

        // Use passive: false to allow preventDefault
        document.addEventListener('wheel', handleScroll, { passive: false });

        return () => {
            document.removeEventListener('wheel', handleScroll);
        };
    }, [isShrunk, hasShrunk]);

    const getUserInfo = async (email, isTrueLoader) => {
        try {
            setDisBtn(true);
            isTrueLoader !== true && setIsLoading(true)
            const res = await axios.get(
                `${API_SERVICE_BACKEND}/getuserdetail/${email}`
            );
            const userData = res.data.data;
            console.log(userData, res.data.data.userSubscription, 'resresresresres')
            setUserDetail(userData);
            setIsLoading(false)
            setSessionStorage(
                "SubscriptionStartDate",
                userData?.userSubscription?.subscriptions?.base?.startDate
            );
            setSessionStorage(
                "SubscriptionEndDate",
                userData?.userSubscription?.subscriptions?.base?.endDate
            );
            setSessionStorage(
                "SubscriptionType",
                userData?.userSubscription?.subscriptions?.base?.planId
            );
            if (userData?.userSubscription) {
                setSessionStorage("Paid", true);
            } else {
                setSessionStorage("Paid", false);
            }
            setDisBtn(false);
        } catch (error) {
            setDisBtn(false);
            setIsLoading(false)
            throw error;
        }
    };
    useEffect(() => {


        if (email) {
            getUserInfo(email, true);
        }
    }, [email]);

    console.log(userDetail, userDetail?.isFreeTrialUsed, 'userDetailuserDetailuserDetailuserDetail')

    useEffect(() => {
        if (userDetail?.userSubscription?.subscriptions?.base?.planId === '7-day') {
            console.log('Free Subscription detected');
            setCurrentSubscription('trial');
        } else {
            if (userDetail?.userSubscription?.subscriptions?.base) {
                const baseSubscription = userDetail.userSubscription.subscriptions.base;
                setCurrentSubscription(baseSubscription.packageName || 'No Active Subscription');
                setDurationInMonth(baseSubscription.durationInMonths || null);
                setUpdatedSubscription(baseSubscription.updatedSubscription?.name || null);
                setUpdateDate(baseSubscription.updatedSubscription?.date || null);
                setCancelledSubscription(baseSubscription?.cancelled || false);
            }
        }
    }, [userDetail]);
    // useEffect(() => {
    //   if (product?.status === 'cancelled') {
    //     setCancelledSubscription(true);
    //   }
    // }, [product]);


    function formatTimestamp(timestamp) {
        const date = new Date(timestamp);
        return date.toLocaleDateString("en-US", {
            day: "numeric",
            month: "short",
            year: "numeric",
        });
    }



    const onRefetch = () => {
        closeCurrentPlanPopover()
        getUserInfo(email)
    }

    const handleCancelSubscription = async () => {
        try {
            // setLoading(true);
            let result = await axios.post(
                `${API_SERVICE_BACKEND}/cancel-subscription`,
                {
                    userEmail: getSessionStorage("userEmail"),
                }
            );

            if (result.status === 200) {
                toast.success("Subscription cancelled!");
                setSubscriptionType('');
                setIsCancelDialogOpen(false)
                const updatedUserData = await getUserInfo(getSessionStorage("userEmail"));

                setUserDetail(updatedUserData);
            } else {
                toast.warn("Something went wrong!");
                setIsCancelDialogOpen(false)
            }

        } catch (err) {
            toast.error("Internal Server Error!");
        }
    };

    const handleManageSubscription = async () => {
        try {
            const baseURL = `${API_SERVICE_BACKEND}/createCustomerPortalSession?userEmail=${sessionStorage.getItem("userEmail")}`;
            const response = await axios.get(baseURL);
            if (response.data.url) {
                window.open(response.data.url, "_blank");
            }
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.error || error?.message);
        }
    }


    return (

        <Box sx={{ height: hideData ? 'auto' : '100vh', display: 'flex', flexDirection: 'column' }} className={!hideData && "glass-wrapper"}>
            {/* Backdrop */}
            <Backdrop
                open={isLoading}
                sx={{
                    color: '#fff',
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                    backdropFilter: 'blur(0px)',
                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                }}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            {/* AppBar */}
            <AppBar className={!hideData && "glass-wrapper"} position={hideData ? 'static' : 'fixed'} elevation={1} sx={{ borderRadius: '0 !important', marginTop: 'auto', height: 50, minHeight: 50, bgcolor: !hideData ? 'background.paper' : 'transparent' }}>
                <Toolbar
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start', // align with marginBottom
                        flexWrap: 'wrap', // optional for responsive
                    }}
                >
                    {/* Left Side (Back to Dashboard) */}


                    <Box sx={{ flexGrow: 1 }}> {hideData ? <Button
                        variant="contained"
                        startIcon={<InfoOutlined sx={{ fontSize: { xs: 16, sm: 20 } }} />}
                        onClick={handleManageSubscription}
                        color="primary"

                        sx={{
                            padding: { xs: '2px 8px', sm: '3px 20px' },
                            fontSize: { xs: '11px', sm: '14px' },
                            minHeight: 32,

                            // mt: !hideData && 1,
                            display: 'flex',
                            // color: theme.palette.text.primary,
                            // backgroundColor: 'transparent',
                            // border: `1px solid ${theme.palette.text.primary}`,
                            '&:hover': {
                                // backgroundColor: theme.palette.primary.main,
                                // border: `1px solid ${theme.palette.primary.main}`,
                                // color: 'white',
                            },
                            // alignItems: 'center',
                            // marginBottom: '11px',
                        }}
                    >
                        Manage Subscription
                    </Button> : <Typography
                        variant="h6"
                        sx={{
                            display: 'flex',
                            color: theme.palette.text.primary,
                            alignItems: 'center',
                            marginBottom: '11px',
                            cursor: 'pointer',
                        }}
                        onClick={() => navigate('/dashboard/campaigns')}
                    >
                        <IconButton color="primary" sx={{ mr: 1 }}>
                            <ArrowBack />
                        </IconButton>
                        Back to Dashboard
                    </Typography>}</Box>

                    {/* Right Side (Buttons) */}
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 2,
                            alignItems: 'center',
                            marginBottom: '11px',
                            flexShrink: 0,
                        }}
                    >
                        <Button
                            variant="contained"
                            startIcon={<Refresh sx={{ fontSize: { xs: 16, sm: 20 } }} />}
                            onClick={onRefetch}
                            sx={{
                                mt: !hideData && 1,
                                padding: { xs: '2px 8px', sm: '3px 20px' },
                                fontSize: { xs: '11px', sm: '14px' },
                                minHeight: 32,
                                // color: 'white',
                                // backgroundColor: theme.palette.primary.main,
                                '&:hover': {
                                    // backgroundColor: theme.palette.primary.main,
                                },
                            }}
                        >
                            Refetch
                        </Button>

                        <Button
                            variant="contained"
                            startIcon={!hideData && <InfoOutlined sx={{ fontSize: { xs: 16, sm: 20 } }} />}
                            onClick={openCurrentPlanPopover}
                            color="primary"
                            sx={{
                                padding: { xs: '2px 8px', sm: '3px 20px' },
                                fontSize: { xs: '11px', sm: '14px' },
                                minHeight: 32,
                                mt: !hideData && 1,
                                // color: 'white',
                                // backgroundColo11r: theme.palette.primary.main,
                                '&:hover': {
                                    // backgroundColor: theme.palette.primary.main,
                                },
                            }}
                        >
                            View Current Plan
                        </Button>




                        <Popover
                            open={isCurrentPlanPopoverOpen}
                            anchorEl={currentPlanAnchor}
                            onClose={closeCurrentPlanPopover}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                            PaperProps={{
                                sx: {
                                    mt: 1,
                                    p: 2,
                                    minWidth: 280,
                                    borderRadius: 2,
                                    boxShadow: 4,
                                    backgroundColor: 'background.paper',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 1.5,
                                },
                            }}
                        >
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Typography variant="subtitle1" fontWeight="bold">
                                    Current Plan
                                </Typography>
                                <IconButton size="small" color="primary" onClick={onRefetch}>
                                    <Refresh fontSize="small" />
                                </IconButton>
                            </Box>

                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Typography variant="body2" color="text.secondary">
                                    {currentSubscription === 'trial' ? (
                                        <strong>7 Days Free Trial</strong>
                                    ) : (
                                        <strong>{currentSubscription || 'No Active Subscription'}</strong>
                                    )}
                                </Typography>
                            </Box>

                            {updatedSubscription && updateDate && (
                                <Typography variant="body2" color="text.secondary">
                                    Will update to <strong>{updatedSubscription} </strong> on{' '}
                                    {/* {durationInMonth === 3 ? 'Quarterly' : 'Yearly'} */}
                                    <strong>{formatTimestamp(updateDate)}</strong>
                                </Typography>
                            )}
                            {cancelledSubscription && (
                                <Typography variant="body2" color="text.secondary">
                                    Your current subscription is active but has been cancelled. It will remain valid until{' '}
                                    <strong>{formatTimestamp(userDetail?.userSubscription?.subscriptions?.base?.endDate)}</strong> and will not renew after that.
                                </Typography>
                            )}




                            <Button
                                variant="contained"
                                color="error"
                                disabled={(
                                    (
                                        userDetail?.freeSubscription !== true &&
                                        !userDetail?.userSubscription?.subscriptions?.base?.packageName
                                    ) ||
                                    currentSubscription === 'trial' ||
                                    currentSubscription === 'No Active Subscription' ||
                                    currentSubscription === '' ||
                                    updatedSubscription ||
                                    cancelledSubscription
                                )
                                }
                                onClick={() => {
                                    closeCurrentPlanPopover();
                                    setIsCancelDialogOpen(true);
                                }}
                                sx={{ minWidth: 100 }}
                            >
                                Cancel Subscription
                            </Button>
                        </Popover>
                    </Box>
                </Toolbar>

            </AppBar>


            {!isLoading && <Box>
                {!isBelow1140 ? <Box>
                    <Box sx={{ position: hideData ? 'relative' : 'fixed', top: hideData ? 'auto' : 64, width: '100%', zIndex: 1000, transition: 'all 0.3s ease', py: isShrunk ? 1 : 3 }}>
                        <Container maxWidth="lg">
                            <Grid container spacing={3} >
                                {transformedData?.map((plan, index) => (
                                    <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        // lg={3}
                                        key={index}

                                        sx={{ display: 'flex', justifyContent: 'center', height: { xs: 'auto', sm: '100%' }, }}
                                    >
                                        <Card
                                            variant="outlined"
                                            className="glass-wrapper-50"
                                            sx={{
                                                textAlign: 'center',
                                                p: 2,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'space-between',
                                                position: 'relative',
                                                overflow: 'visible',
                                                borderRadius: 2,
                                                boxShadow: '0 6px 25px rgba(72, 61, 139, 0.5)',
                                                height: '100%',
                                                minWidth: hideData ? '330px' : '360px',
                                                maxWidth: '300px',
                                                '&::before': {
                                                    content: '""',
                                                    position: 'absolute',
                                                    top: '-2px',
                                                    left: '-2px',
                                                    right: '-2px',
                                                    bottom: '-2px',
                                                    borderRadius: '18px',
                                                    padding: '3px', // This determines border thickness
                                                    background: plan?.name === 'Scale' ?
                                                        'linear-gradient(0deg, rgba(255,186,113,1) 6%, rgba(198,134,255,1) 19%, rgba(255,103,120,1) 30%, rgba(170,110,238,1) 42%, rgba(141,153,255,1) 64%, rgba(245,185,234,1) 76%, rgba(188,130,243,1) 83%)' :
                                                        'transparent',
                                                    WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                                                    WebkitMaskComposite: 'xor',
                                                    maskComposite: 'exclude',
                                                    zIndex: 0,
                                                    filter: 'drop-shadow(0 0 8px rgba(170, 110, 238, 0.5))'

                                                }
                                            }}
                                            ref={cardsRef}
                                        >
                                            {/* Gradient Border */}


                                            <CardContent sx={{ p: 0, paddingBottom: "0 !important", height: '100%', display: 'flex', flexDirection: 'column' }}>

                                                {/* --- Top Section --- */}
                                                <Box sx={{ flexGrow: 1 }}>
                                                    {/* Header, Switch */}
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                            <Typography variant="h6" component="div" fontWeight="bold">
                                                                {plan?.name}
                                                            </Typography>

                                                            {plan?.name === 'Scale' && (
                                                                <Chip
                                                                    label="Popular"
                                                                    sx={{
                                                                        bgcolor: '#4f46e5',
                                                                        color: 'white',
                                                                        borderRadius: 1,
                                                                        border: '1px solid #5862FF',
                                                                        height: isShrunk ? 25 : 28,
                                                                        px: 1.2,
                                                                        background: 'rgb(142 147 255)',
                                                                        fontSize: '0.75rem',
                                                                    }}
                                                                />
                                                            )}
                                                        </Box>


                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                            <Typography variant="body2" >
                                                                {packageIntervals[index] || 'yearly'}
                                                            </Typography>

                                                            <Switch
                                                                checked={(packageIntervals[index] || 'yearly') === 'yearly'}
                                                                onChange={() => handleSwitchChange(index)}
                                                                sx={{
                                                                    width: 42,
                                                                    height: 26,
                                                                    padding: 0,
                                                                    '& .MuiSwitch-switchBase': {
                                                                        padding: '1px !important',
                                                                        '&.Mui-checked': {
                                                                            transform: 'translateX(16px)',
                                                                            color: '#fff',
                                                                            '& + .MuiSwitch-track': {
                                                                                backgroundColor: '#10b981',
                                                                                opacity: 1,
                                                                                border: 0,
                                                                            },
                                                                        },
                                                                    },
                                                                    '& .MuiSwitch-thumb': {
                                                                        backgroundColor: '#fff',
                                                                        width: 24,
                                                                        height: 24,
                                                                    },
                                                                    '& .MuiSwitch-track': {
                                                                        borderRadius: 26 / 2,
                                                                        backgroundColor: '#bfbfbf',
                                                                        opacity: 1,
                                                                        transition: 'background-color 0.3s',
                                                                    },
                                                                }}
                                                            />
                                                        </Box>

                                                    </Box>{console.log(plan, 'planplanplanplan')}

                                                    {/* Pricing */}
                                                    <Box sx={{ mb: isShrunk ? '-4px !important' : '16px !important', textAlign: 'left' }}>
                                                        {/* Only show the crossed-out original price if the plan is not "Free" and the selected package is yearly */}
                                                        {plan?.name !== 'Free' && packageIntervals[index] === 'yearly' && (
                                                            <Typography
                                                                variant="body2"
                                                                sx={{
                                                                    textDecoration: 'line-through',
                                                                    display: 'inline',
                                                                    mr: 1,
                                                                    fontSize: !isShrunk ? "26px !important" : "15px !important",
                                                                }}
                                                            >
                                                                ${Math.round(plan?.monthlyPrice[packageIntervals[index]] * 1.334)}
                                                            </Typography>
                                                        )}

                                                        {/* Display the current monthly or yearly price based on selected package interval */}
                                                        <Typography
                                                            variant="h3"
                                                            component="div"
                                                            sx={{
                                                                display: 'inline',
                                                                fontWeight: 'bold',
                                                                fontSize: !isShrunk ? "36px !important" : "20px !important",
                                                            }}
                                                        >
                                                            {/* If selected package interval is yearly, apply a 25% discount to the monthly price */}
                                                            ${packageIntervals[index] === 'yearly'
                                                                ? plan?.monthlyPrice[packageIntervals[index]]  // 25% off the yearly amount
                                                                : plan?.monthlyPrice[packageIntervals[index]]
                                                            }
                                                        </Typography>

                                                        {/* Display the interval (month/year) based on the selected package interval */}
                                                        <Typography variant="body2" component="div" sx={{ display: 'inline', ml: 0.5 }}>
                                                            / Per month
                                                        </Typography>
                                                    </Box>


                                                    {!isShrunk && <Typography variant="body2" sx={{ textAlign: 'left' }}>
                                                        Billed {packageIntervals[index]}
                                                    </Typography>}

                                                    {/* Features */}
                                                    {!isShrunk && (
                                                        <>
                                                            {plan?.featureLable && (
                                                                <Box sx={{ display: 'flex', alignItems: 'center', mt: 3 }}>
                                                                    <Typography variant="body1">Everything in</Typography>
                                                                    <Chip
                                                                        label={plan?.featureLable}
                                                                        sx={{
                                                                            bgcolor: '#4f46e5',
                                                                            color: 'white',
                                                                            border: '1px solid #5862FF',
                                                                            height: isShrunk ? "28px  !important" : "25px  !important",
                                                                            mr: '2px',
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: 'center',
                                                                            background: "rgb(142 147 255)",
                                                                            borderRadius: 2,
                                                                            ml: 1,
                                                                        }}
                                                                    />
                                                                    <Typography variant="body1">, plus:</Typography>
                                                                </Box>
                                                            )}

                                                            <List sx={{
                                                                mb: 1,
                                                                minHeight: 160,
                                                                transition: 'all 0.3s ease',
                                                                opacity: hideList ? 0 : 1,
                                                                overflow: 'hidden',
                                                                transform: hideList ? 'translateY(-10px)' : 'translateY(0)',
                                                                pointerEvents: hideList ? 'none' : 'auto',
                                                            }}>
                                                                {plan?.featuresList2.map((item) => (
                                                                    <ListItem key={item} sx={{ p: 0 }}>
                                                                        <ListItemIcon sx={{ minWidth: 36 }}>
                                                                            <CheckCircleIcon sx={{ color: '#00AA38' }} />
                                                                        </ListItemIcon>
                                                                        <ListItemText
                                                                            sx={{
                                                                                fontWeight: 'bold',
                                                                            }}
                                                                            primary={item}
                                                                        />
                                                                    </ListItem>
                                                                ))}
                                                            </List>
                                                        </>
                                                    )}
                                                </Box>

                                                {/* --- Bottom Section (Button) --- */}
                                                <Box>{console.log(isSubscribedToPaidPlan, subscriptionType, 'isSubscribedToPaidPlan=>')}
                                                    <Button
                                                        variant="contained"
                                                        fullWidth
                                                        onClick={handleOpenTrialModal}
                                                        disabled={cancelledSubscription || subscriptionType === 'trial' || isSubscribedToPaidPlan || userDetail?.isFreeTrialUsed}
                                                        sx={{
                                                            bgcolor: 'transparent',
                                                            color: theme => theme.palette.text.primary,
                                                            boxShadow: 'none',
                                                            borderRadius: 2,
                                                            py: 1.5,
                                                            padding: isShrunk ? "7px 11px !important" : "10px !important",
                                                            fontSize: isShrunk && "12px !important",
                                                            textTransform: 'none',
                                                            '&:hover': {
                                                                bgcolor: 'transparent',
                                                                boxShadow: 'none',
                                                            },
                                                            '&.Mui-disabled': {
                                                                bgcolor: 'transparent',
                                                                color: theme => theme.palette.text.secondary,
                                                                opacity: 0.7, // optional: make it a little faded if you want
                                                            }
                                                        }}
                                                    >
                                                        Free Trial
                                                    </Button>
                                                    {console.log(durationInMonth, packageIntervals[index], plan, currentSubscription, 'currentSubscriptioncurrentSubscription')}
                                                    <Button
                                                        variant="contained"
                                                        fullWidth
                                                        endIcon={<ArrowRight sx={{ fontSize: isShrunk && "12px !important" }} />}
                                                        disabled={
                                                            (currentSubscription.includes(plan.name) &&
                                                                durationInMonth === (packageIntervals[index] === 'yearly' ? 12 : 3)) ||
                                                            cancelledSubscription || subscriptionID === plan.prices?.[packageIntervals[index]]?.id}
                                                        sx={{
                                                            padding: isShrunk && "7px 11px !important",
                                                            fontSize: isShrunk && "12px !important",
                                                            // bgcolor: '#4f46e5',
                                                            borderRadius: 2,
                                                            py: 1.5,
                                                            textTransform: 'none',
                                                            // color: theme.palette.text.secondary,
                                                            backgroundColor: theme.palette.primary.main,
                                                            // '&:hover': {
                                                            //   backgroundColor: theme.palette.primary.main,
                                                            // },
                                                            '&.Mui-disabled': {
                                                                // color: theme.palette.text.primary,
                                                                // backgroundColor: theme.palette.primary.main,
                                                                opacity: 0.7,
                                                            }
                                                        }}
                                                        onClick={() => handleButtonClick(plan)}
                                                    >
                                                        {isSubscribedToPaidPlan
                                                            ? 'Update Plan'
                                                            : subscriptionID === plan.prices?.[packageIntervals[index]]?.id
                                                                ? 'Your Current Plan'
                                                                : 'Choose Plan'}
                                                    </Button>


                                                </Box>


                                            </CardContent>
                                        </Card>
                                        {/* </Box> */}

                                    </Grid>
                                ))}
                                <UpgradeConfirmModal
                                    open={showUpgradeConfirmDialog}
                                    onClose={() => setShowUpgradeConfirmDialog(false)}
                                    onConfirm={handleConfirmUpgrade}
                                    currentSubscription={currentSubscription}
                                    selectedPlan={selectedPlan}
                                />

                                <FreeTrialModal
                                    open={openTrialModal}
                                    handleClose={handleCloseTrialModal}
                                    handleSubmit={handleFreeTrialSubscription}
                                    planDetails={freeTrialObject}
                                />


                                {/* One-Time Payment Dialog */}
                                <OneTimePaymentModal
                                    open={showOneTimeCostDialog}
                                    onClose={() => setShowOneTimeCostDialog(false)}
                                    onConfirm={handleConfirmOneTimeCost}
                                    selectedPlan={selectedPlan}
                                />

                                {/* Coupon Dialog */}
                                <Dialog
                                    open={showCouponDialog}
                                    onClose={() => setShowCouponDialog(false)}
                                    maxWidth="sm"
                                    fullWidth
                                >
                                    <DialogTitle>Enter Coupon Code</DialogTitle>
                                    <DialogContent>
                                        <TextField
                                            autoFocus
                                            margin="dense"
                                            label="Coupon Code"
                                            type="text"
                                            fullWidth
                                            variant="outlined"
                                            value={couponCode}
                                            onChange={(e) => setCouponCode(e.target.value)}
                                        />
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={() => handleUpgradeWithCoupon('')}>Skip</Button>
                                        <Button onClick={() => handleUpgradeWithCoupon(couponCode)}>Apply</Button>
                                    </DialogActions>
                                </Dialog>

                                <Dialog
                                    open={isCancelDialogOpen}
                                    onClose={() => setIsCancelDialogOpen(false)}
                                >
                                    <DialogTitle>Cancel Subscription</DialogTitle>
                                    <DialogContent>
                                        <DialogContentText>
                                            Are you sure you want to cancel your subscription? This action cannot be undone.
                                        </DialogContentText>
                                    </DialogContent>

                                    <DialogActions>
                                        <Button onClick={() => setIsCancelDialogOpen(false)} color="primary">
                                            No
                                        </Button>
                                        <Button
                                            onClick={() => {
                                                handleCancelSubscription(); // Call your cancel function
                                                setIsCancelDialogOpen(false); // Close Dialog
                                            }}
                                            color="error"
                                            variant="contained"
                                        >
                                            Yes, Cancel
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                            </Grid>
                        </Container>
                    </Box>

                    {!hideData && <Box ref={scrollRef} sx={{ position: 'absolute', top: !isShrunk ? `${Math.max(cardsHeight, 550)}px` : cardsHeight < 260 ? `${Math.max(260)}px` : `${Math.max(cardsHeight)}px`, bottom: 0, width: '100%', overflowY: 'scroll' }}>
                        <Container maxWidth="lg">
                            {data.map((section, sectionIndex) => (
                                <Box key={sectionIndex} sx={{ mb: 4 }}>
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            mb: 2,
                                            fontWeight: 'bold',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1,
                                            // position: 'sticky',
                                            // top: 0,
                                            // backgroundColor: 'background.paper', // or '#fff' depending on your theme
                                            zIndex: 10,
                                            py: 1, // optional: add a bit of padding
                                        }}
                                    >
                                        {section.icon} {section.section}
                                    </Typography>


                                    <TableContainer
                                        component={Paper}
                                        sx={{
                                            my: 2,
                                            borderRadius: 2,
                                            backgroundColor: 'transparent', // Remove Paper background
                                            boxShadow: 'none', // Remove Paper shadow
                                        }}
                                    >
                                        <Table sx={{ backgroundColor: 'transparent' }}>
                                            <TableBody>
                                                {section.features.map((feature, featureIndex) => (
                                                    <TableRow key={featureIndex} sx={{ backgroundColor: 'transparent' }}>
                                                        {feature.plans.map((val, i) => (
                                                            <TableCell
                                                                key={i}
                                                                sx={{
                                                                    backgroundColor: 'transparent',
                                                                    borderBottom: 'none', // optional: remove bottom borders
                                                                }}
                                                            >
                                                                <Grid item xs={3}>
                                                                    <FeatureIconMain value={val} title={feature.title} />
                                                                </Grid>
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                </Box>
                            ))}

                        </Container>
                    </Box>
                    }
                </Box>
                    : <Box sx={{ flex: 1, mt: '75px', overflowY: 'auto', px: 2 }}>
                        <Grid container spacing={3}>
                            {transformedData?.map((plan, index) => (
                                <Grid item xs={12} key={index} sx={{ display: 'flex', justifyContent: 'center' }}>

                                    <Card
                                        variant="outlined"
                                        className="glass-wrapper-50"
                                        sx={{
                                            position: 'relative',
                                            display: 'flex',
                                            flexDirection: { xs: 'column', sm: 'row' },
                                            width: '100%',
                                            borderRadius: 3,
                                            overflow: 'hidden',
                                            border: 'none', // Remove the default Card border
                                            background: 'transparent', // Ensure card background is transparent
                                            boxShadow: 2,
                                            '&::before': {
                                                content: '""',
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                right: 0,
                                                bottom: 0,
                                                borderRadius: '22px', // Match the Card's borderRadius (3 = 24px in MUI)
                                                padding: '5px', //7px Reduced border thickness
                                                background: plan?.name === 'Scale' ?
                                                    'linear-gradient(0deg, rgba(255,186,113,1) 6%, rgba(198,134,255,1) 19%, rgba(255,103,120,1) 30%, rgba(170,110,238,1) 42%, rgba(141,153,255,1) 64%, rgba(245,185,234,1) 76%, rgba(188,130,243,1) 83%)' :
                                                    'transparent',
                                                WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                                                WebkitMaskComposite: 'xor',
                                                maskComposite: 'exclude',
                                                zIndex: 0,
                                                filter: 'drop-shadow(0 0 6px rgba(170, 110, 238, 0.4))'
                                            }
                                        }}
                                    >
                                        {/* Left Side Content */}
                                        <Box sx={{ p: 3, flex: 1, position: 'relative' }}>
                                            {/* Top Row: Plan Name + Popular Chip (left), Switch (right) */}
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <Typography variant="h6" fontWeight="bold">
                                                        {plan?.name}
                                                    </Typography>
                                                    {plan?.name === 'Scale' && (
                                                        <Chip
                                                            label="Popular"
                                                            sx={{
                                                                bgcolor: '#4f46e5',
                                                                color: 'white',
                                                                borderRadius: 1,
                                                                border: '1px solid #5862FF',
                                                                height: 24,
                                                                fontSize: 12,
                                                                background: 'rgb(142 147 255)',
                                                            }}
                                                        />
                                                    )}
                                                </Box>

                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <Typography variant="body2">
                                                        {packageIntervals[index] || 'yearly'}
                                                    </Typography>
                                                    <Switch
                                                        checked={(packageIntervals[index] || 'yearly') === 'yearly'}
                                                        onChange={() => handleSwitchChange(index)}
                                                        sx={{
                                                            width: 42,
                                                            height: 26,
                                                            padding: 0,
                                                            '& .MuiSwitch-switchBase': {
                                                                padding: '1px !important',
                                                                '&.Mui-checked': {
                                                                    transform: 'translateX(16px)',
                                                                    color: '#fff',
                                                                    '& + .MuiSwitch-track': {
                                                                        backgroundColor: '#10b981',
                                                                        opacity: 1,
                                                                        border: 0,
                                                                    },
                                                                },
                                                            },
                                                            '& .MuiSwitch-thumb': {
                                                                backgroundColor: '#fff',
                                                                width: 24,
                                                                height: 24,
                                                            },
                                                            '& .MuiSwitch-track': {
                                                                borderRadius: 13,
                                                                backgroundColor: '#bfbfbf',
                                                                opacity: 1,
                                                                transition: 'background-color 0.3s',
                                                            },
                                                        }}
                                                    />
                                                </Box>
                                            </Box>

                                            {/* Pricing */}
                                            <Box sx={{ mb: 1 }}>
                                                {plan?.name !== 'Free' && packageIntervals[index] === 'yearly' && (
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            textDecoration: 'line-through',
                                                            display: 'inline',
                                                            mr: 1,
                                                            fontSize: '16px',
                                                        }}
                                                    >
                                                        ${Math.round(plan?.monthlyPrice[packageIntervals[index]] * 1.334)}
                                                    </Typography>
                                                )}
                                                <Typography variant="h4" component="span" sx={{ fontWeight: 'bold' }}>
                                                    ${plan?.monthlyPrice[packageIntervals[index]]}
                                                </Typography>
                                                <Typography variant="body2" component="span" sx={{ ml: 0.5 }}>
                                                    / month
                                                </Typography>
                                            </Box>

                                            <Typography variant="body2" color="text.secondary" mb={2}>
                                                Billed {packageIntervals[index]}
                                            </Typography>

                                            {/* Feature Label */}
                                            {plan?.featureLable && (
                                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                                    <Typography variant="body1">Everything in</Typography>
                                                    <Chip
                                                        label={plan?.featureLable}
                                                        sx={{
                                                            bgcolor: '#4f46e5',
                                                            color: 'white',
                                                            border: '1px solid #5862FF',
                                                            height: '25px',
                                                            mx: 1,
                                                            background: 'rgb(142 147 255)',
                                                            borderRadius: 2,
                                                        }}
                                                    />
                                                    <Typography variant="body1">, plus:</Typography>
                                                </Box>
                                            )}

                                            {/* Buttons */}
                                            <Button
                                                variant="contained"
                                                fullWidth
                                                onClick={handleOpenTrialModal}
                                                disabled={cancelledSubscription || subscriptionType === 'trial' || isSubscribedToPaidPlan || userDetail?.isFreeTrialUsed}
                                                sx={{
                                                    bgcolor: 'transparent',
                                                    color: theme => theme.palette.text.primary,
                                                    boxShadow: 'none',
                                                    borderRadius: 2,
                                                    py: 1.5,
                                                    textTransform: 'none',
                                                    mb: 1,
                                                    '&:hover': {
                                                        bgcolor: 'transparent',
                                                        boxShadow: 'none',
                                                    },
                                                    '&.Mui-disabled': {
                                                        bgcolor: 'transparent',
                                                        color: theme => theme.palette.text.secondary,
                                                        opacity: 0.7,
                                                    }
                                                }}
                                            >
                                                Free Trial
                                            </Button>

                                            <Button
                                                variant="contained"
                                                fullWidth
                                                endIcon={<ArrowRight />}
                                                onClick={() => handleButtonClick(plan)}
                                                disabled={(currentSubscription.includes(plan.name) &&
                                                    durationInMonth === (packageIntervals[index] === 'yearly' ? 12 : 3)) ||
                                                    cancelledSubscription || subscriptionID === plan.prices?.[packageIntervals[index]]?.id}
                                                sx={{
                                                    // color: theme.palette.text.primary,
                                                    // backgroundColor: theme.palette.primary.main,
                                                    // color: theme.palette.text.primary,
                                                    // backgroundColor: theme.palette.primary.main,
                                                    // '&:hover': {
                                                    //   backgroundColor: theme.palette.primary.main,
                                                    // },
                                                    borderRadius: 2,
                                                    py: 1.5,
                                                    textTransform: 'none',
                                                    '&.Mui-disabled': {
                                                        // color: theme.palette.text.primary,
                                                        // backgroundColor: theme.palette.primary.main,
                                                        opacity: 0.7,
                                                    }
                                                }}
                                            >
                                                {isSubscribedToPaidPlan
                                                    ? 'Update Plan'
                                                    : subscriptionID === plan.prices?.[packageIntervals[index]]?.id
                                                        ? 'Your Current Plan'
                                                        : 'Choose Plan'}
                                            </Button>
                                        </Box>

                                        {/* Right Side: Features */}
                                        <Box sx={{ p: 3, minWidth: { sm: 250 } }}>
                                            <Typography variant="subtitle1" fontWeight="bold" mb={1}>
                                                Features
                                            </Typography>
                                            <List>
                                                {plan?.featuresList2?.map((item, idx) => (
                                                    <ListItem key={idx} disablePadding>
                                                        <ListItemIcon>
                                                            <CheckCircleIcon sx={{ color: '#00AA38' }} />
                                                        </ListItemIcon>
                                                        <ListItemText primary={item} />
                                                    </ListItem>
                                                ))}
                                            </List>
                                        </Box>
                                    </Card>
                                </Grid>

                            ))}

                        </Grid>
                        <UpgradeConfirmModal
                            open={showUpgradeConfirmDialog}
                            onClose={() => setShowUpgradeConfirmDialog(false)}
                            onConfirm={handleConfirmUpgrade}
                            selectedPlan={selectedPlan}
                        />

                        <FreeTrialModal
                            open={openTrialModal}
                            handleClose={handleCloseTrialModal}
                            handleSubmit={handleFreeTrialSubscription}
                            planDetails={freeTrialObject}
                        />


                        {/* One-Time Payment Dialog */}
                        <OneTimePaymentModal
                            open={showOneTimeCostDialog}
                            onClose={() => setShowOneTimeCostDialog(false)}
                            onConfirm={handleConfirmOneTimeCost}
                            selectedPlan={selectedPlan}
                        />

                        {/* Coupon Dialog */}
                        <Dialog
                            open={showCouponDialog}
                            onClose={() => setShowCouponDialog(false)}
                            maxWidth="sm"
                            fullWidth
                        >
                            <DialogTitle>Enter Coupon Code</DialogTitle>
                            <DialogContent>
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    label="Coupon Code"
                                    type="text"
                                    fullWidth
                                    variant="outlined"
                                    value={couponCode}
                                    onChange={(e) => setCouponCode(e.target.value)}
                                />
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => handleUpgradeWithCoupon('')}>Skip</Button>
                                <Button onClick={() => handleUpgradeWithCoupon(couponCode)}>Apply</Button>
                            </DialogActions>
                        </Dialog>

                        <Dialog
                            open={isCancelDialogOpen}
                            onClose={() => setIsCancelDialogOpen(false)}
                        >
                            <DialogTitle>Cancel Subscription</DialogTitle>
                            <DialogContent>
                                <DialogContentText>
                                    Are you sure you want to cancel your subscription? This action cannot be undone.
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <Button onClick={() => setIsCancelDialogOpen(false)} color="primary">
                                    No
                                </Button>
                                <Button
                                    onClick={() => {
                                        handleCancelSubscription(); // Call your cancel function
                                        setIsCancelDialogOpen(false); // Close Dialog
                                    }}
                                    color="error"
                                    variant="contained"
                                >
                                    Yes, Cancel
                                </Button>
                            </DialogActions>
                        </Dialog>
                        {!hideData && <Container maxWidth="lg" disableGutters sx={{ mt: 4 }}>



                            {data.map((section, sectionIndex) => (
                                <Box key={sectionIndex} sx={{ mb: 4 }}>
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            mb: 2,
                                            mt: 2,
                                            fontWeight: 'bold',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1,
                                            py: 1,
                                        }}
                                    >
                                        {section.icon} {section.section}
                                    </Typography>

                                    {/* No Paper = no background/border */}
                                    <TableContainer sx={{ boxShadow: 'none' }}>
                                        <Table sx={{ borderCollapse: 'collapse' }}>
                                            <TableBody>
                                                {section.features.map((feature, featureIndex) => (
                                                    <React.Fragment key={featureIndex}>
                                                        <TableRow sx={{ border: 'none' }}>
                                                            <TableCell
                                                                colSpan={section.features.length}
                                                                sx={{ border: 'none', py: 1 }}
                                                            >
                                                                <Typography variant="body2" color="text.secondary">
                                                                    {feature.title}
                                                                </Typography>
                                                            </TableCell>
                                                        </TableRow>

                                                        <TableRow sx={{ border: 'none' }}>
                                                            {feature.plans.map((val, i) => (
                                                                <TableCell
                                                                    key={i}
                                                                    align="center"
                                                                    sx={{ border: 'none', py: 1 }}
                                                                >
                                                                    <FeatureIcon value={val} title={feature.title} />
                                                                </TableCell>
                                                            ))}
                                                        </TableRow>
                                                    </React.Fragment>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                </Box>
                            ))}
                        </Container>}

                    </Box>}


            </Box>}


        </Box>

    );
}
